'use strict';

export default function routes($stateProvider) {
  'ngInject';
  $stateProvider.state('reporting', {
    url: '/reporting',
    template: '<reporting></reporting>',
    authenticate: true
  });
}



// WEBPACK FOOTER //
// ./client/app/reporting/reporting.routes.js